import Matrix from './matrix';

import LuDecomposition from './dc/lu';
import QrDecomposition from './dc/qr';

export function inverse(matrix) {
    matrix = Matrix.checkMatrix(matrix);
    return solve(matrix, Matrix.eye(matrix.rows));
}

export function solve(leftHandSide, rightHandSide) {
    leftHandSide = Matrix.checkMatrix(leftHandSide);
    rightHandSide = Matrix.checkMatrix(rightHandSide);
    return leftHandSide.isSquare() ? new LuDecomposition(leftHandSide).solve(rightHandSide) : new QrDecomposition(leftHandSide).solve(rightHandSide);
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression-polynomial/~/ml-matrix/src/decompositions.js
// module id = 45
// module chunks = 0